<script>

export default {
    name: "ConfirmRecordResult",

    props: {

        showModal: Boolean,
        result: Object,
    },

    methods: {
       fetchTotalRadiologyQueue() {
      return this.$http
        .get(`Radiology/GetTotalRadiologyQueue`)
        .then((response) => {
          this.$root.pendingRadiologyQueue = response.data;
        })
        .catch(() => {});
    },
        saveResults() {

            this.$root.loading = true;
            this.$http.post(`Radiology/RecordRadiologyResults`, this.result).then(response => {
                this.$emit(`refresh`);
                this.$root.loading = false;
                this.fetchTotalRadiologyQueue();
                window.Swal.fire({ text: response.data, type: `success`});
                this.$emit(`closeModal`);
            }).catch(() => { this.$root.loading = false; this.$emit(`closeModal`); });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/4 sm:w-11/12">
      <template v-slot:title>
        <h5 class="font-medium text-base">Confirm record tests</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap justify-center -m-3">
            <h5 class="font-bold text-red-600">Confirm record tests!</h5>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs mr-8" @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-xs" @click.prevent="saveResults"><i class="fa fa-save"></i> Save</button>
      </template>
    </tail-modal>
</template>